<template>
    <div>
        <question :text="$t(item.text)" />
        <b-row class="mt-5 number-input__input-field">
            <b-col cols="10" sm="10" md="8">
                <div>
                    <text-input
                        @change="handleChange"
                        text-type="number"
                        :format="format"
                        :validator="validate"
                        :error-text="errorText"
                        :locale="locale"
                    />
                </div>
            </b-col>
            <b-col cols="1">
                <h3>
                {{ $t(`${this.item.text}_DESCRIPTION_FIELD`, { currency: locale.currency }) }}
                </h3>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import textInput from '@/components/inputs/text'
import question from '@/components/ui/question'

export default {
    name: 'numInputItem',
    components: {
        question,
        'text-input': textInput,
    },
    props: {
        item: {
            type: Object,
        },
        locale: {
            type: Object
        },
        itemProperties: {
            type: Object
        }
    },
    computed: {
        errorText() {
            return this.$t(`${this.item.text}_NUM_VAL_ERROR`, { 
                currency: this.locale.currency, 
                min: this.item.scaleMin.toLocaleString(this.locale.tag), 
                max: this.item.scale.toLocaleString(this.locale.tag) 
            })
        },
        format() {
            if(this.itemProperties.getProperty('formatter') === 'false') {
                return false
            } else {
                return true
            }
        }
    },
    methods: {
        handleChange(number) {
            if(number || number === 0) {
                const result = parseInt(number)
                this.$emit('answer', { result })
            } else {
                this.$emit('answer', null)
            }
        },
        validate(input) {
            const numberRegex = /^-?\d+$/;
            const number = parseInt(input);

            return numberRegex.test(input) && number >= this.item.scaleMin && number <= this.item.scale;
        }
    }
}
</script>
<style lang="scss">
.number-input__input-field {
    min-height: 90px;
}
</style>
